// ─────────────────────────────────────────────────────────────────────────────
// Google Sheets webhook URLs
// Paste the Apps Script Web App deployment URL(s) here when ready.
// Both forms that write to the Enquiries sheet share ENQUIRIES_WEBHOOK_URL.
// The Testimonials form uses its own separate sheet / deployment URL.
// ─────────────────────────────────────────────────────────────────────────────

// Admissions form + Contact form → "Enquiries" Google Sheet
export const ENQUIRIES_WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbwvMnNL-vDZuns7RV9Wp6oifE1OYWbXKl5GF0T5sR1d3xzvJJVKnNMtLO8SbMZjpOO2Bg/exec';

// Testimonials page form → "Testimonials" Google Sheet (separate file)
export const TESTIMONIALS_WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycby0ojJ4xiDFjNyPMQbzoUn8vqQ9psQUciOI75oWXiCo-mdx8cu0ulFW5_nQoWIeB4q6tA/exec';
